<template lang="html">
  <modal
    name="new-ownership-modal"
    height="auto" width="416"
    :adaptive="true"
    :maxWidth="416"
    class="edit-vendor-modal"
    @before-open="beforeOpen"
  >
    <div class="modal-container">
      <div class="modal-header">
        New {{ownership.type}} Subscription
      </div>
      <div class="line-break" />
      <div class="modal-body">
        <div class="bold">
          Select An existing Organization to add {{ownership.type}}
          subscription Or type a new organization name
        </div>
        <div class="gap-1x" />
        <select class="select" @change="assignOrg">
          <option>-</option>
          <option v-for="org in availableOrgs" :value="org[0]" :key="org[0]">{{org[1]}}</option>
        </select>
        <div class="gap-2x" />
        <div v-if="!ownership.organization_id">
          <input placeholder="Org Name" type="text" v-model="ownership.organization_name">
          <div class="gap-3x" />
          <div class="bold">Admin Email</div>
          <input v-model="ownership.email" />
          <div class="gap-3x" />
          <div class="bold">First Name</div>
          <input v-model="ownership.first_name" />
          <div class="gap-3x" />
          <div class="bold">Last Name</div>
          <input v-model="ownership.last_name" />
          <div class="gap-3x" />
          <div class="bold">Phone</div>
          <input v-model="ownership.phone" />
          <div class="bold">Organization Jurisdiction</div>
          <input v-model="ownership.organization_jurisdiction" />
        </div>
        <div class="gap-3x" />
        <div class="bold">Expires</div>
        <DatePicker
          @selected="(selectedDate) => { ownership.expires = selectedDate }"
          :currentDate="ownership.expires"
        />
        <div class="gap-3x" />
        <div class="bold">Number Of Licenses</div>
        <input v-model="ownership.licenses" type="number" />
      </div>
      <div class="line-break" />
      <ModalFooter
        :save="save"
        :cancel="() => $modal.hide('new-ownership-modal')"
        :rightActionLoading="loading"
      />
    </div>
  </modal>
</template>

<script>
import ModalFooter from 'src/components/common/modals/shares/ModalFooter.vue'
import DatePicker from 'src/components/common/form/SymbiumDatePicker.vue'

export default {
  components: { ModalFooter, DatePicker },
  data() {
    return {
      ownership: {},
      loading: false,
      availableOrgs: []
    }
  },
  methods: {
    assignOrg(event) {
      this.ownership = {
        ...this.ownership,
        organization_name: event.target.selectedOptions[0].innerText,
        organization_id: event.target.value,
      }
    },
    save() {
      this.loading = true;
      this.$ownership.create(this.ownership, this.afterUpdate, this.updateErrorHandler)
    },
    afterUpdate() {
      this.$modal.hide('new-ownership-modal')
      this.$emit('created')
    },
    updateErrorHandler() {
      this.loading = false
      alert("Something went wrong, please try again!")
    },
    beforeOpen(event) {
      this.ownership = { type: event.params.type, expires: new Date() }
      this.availableOrgs = []
      this.loading = false
      this.$ownership.fetchAvailableOrgs(event.params.type, (response) => {
        this.availableOrgs = response.data.data
      })
    }
  },
}
</script>

<style lang="scss">
.modal-body {
  min-height: auto !important;

  input, select {
    width: 100%;
  }
}

.edit-vendor-modal {
  .modal-body {
    max-height: calc(100vh - 224px) !important;
  }
}
</style>
